module.exports = __webpack_public_path__ + "img/tiering-bag-icon.99301cba.svg";